<!-- Page header: breadcrumb trail + title -->
<div class="page-breadcrumb">
  <nav class="ps-breadcrumbs" aria-label="Breadcrumb" *ngIf="pageInfo?.urls?.length">
    <ol>
      <ng-template ngFor let-url [ngForOf]="pageInfo?.urls" let-last="last">
        <li [class.active]="last">
          <a *ngIf="!last && url.url" [routerLink]="url.url">{{ url.title }}</a>
          <span *ngIf="!last && !url.url">{{ url.title }}</span>
          <span *ngIf="last" aria-current="page">{{ url.title }}</span>
          <svg *ngIf="!last" class="ps-breadcrumbs__sep" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </li>
      </ng-template>
    </ol>
  </nav>
  <h4 class="page-title m-0">{{ pageInfo?.title }}</h4>
</div>
